<template>
  <div class="block">
    <div
        class="inline-block bg-blue-400 bg-opacity-80 p-2 ml-2 w-4 h-4 rounded-full animate-bounce blue-circle"
    ></div>
    <div
        class="inline-block  bg-blue-400 bg-opacity-80 ml-2 p-2 w-4 h-4 rounded-full animate-bounce green-circle"
    ></div>
    <div
        class="inline-block  bg-blue-400 bg-opacity-80 p-2 ml-2 w-4 h-4 rounded-full animate-bounce red-circle"
    ></div>
  </div>
</template>

<script>
    export default {
        props: ['value']
    }
</script>

<style scoped>
.blue-circle {
  animation-delay: 0.1s;
}

.green-circle {
  animation-delay: 0.2s;
}

.red-circle {
  animation-delay: 0.3s;
}
</style>